export const LOCALES = ['en', 'sv'] as const;
export type Locale = (typeof LOCALES)[number];

export const DEFAULT_LOCALE: Locale = 'en';

// Cookie that stores the user's explicit language choice. Shares the same name
// as the marketing site (queri.law) so a visitor's choice carries across to the
// app when both are served from *.queri.law.
export const LOCALE_COOKIE = 'queri_lang';
export const LOCALE_COOKIE_MAX_AGE = 60 * 60 * 24 * 365; // 1 year

export function isLocale(value: unknown): value is Locale {
  return (
    typeof value === 'string' && (LOCALES as readonly string[]).includes(value)
  );
}

export const LOCALE_LABELS: Record<
  Locale,
  { label: string; flag: string; short: string }
> = {
  en: { label: 'English', flag: '🇬🇧', short: 'EN' },
  sv: { label: 'Svenska', flag: '🇸🇪', short: 'SV' },
};
